<template>
    <div>
        <Nav></Nav>
        <PageHeader :linkto="'/home'" :linkttitle="'返回'" :title="productName"></PageHeader>
        <b-container class="bg-white p-3 p-md-5 shadow-sm rounded mb-3 ">
            <b-card v-if="profiledata.lineLogin==0" class="shadow-lg mb-5" border-variant="success">
                <h5 class="mb-3">連結LINE帳號</h5>
                <p>連結LINE帳號，往後只需使用LINE即可登入!</p>
                <b-button   pill variant="success" block @click="bindLine" >連結LINE帳號</b-button>
            </b-card>
            <h5 class="mb-3">我的資料</h5>
            <TipsAlert text="緣分只是一個摸不著的東西，而在中國古代，大家更是相信緣分天定的說法。今天小桃就來告訴大家一種緣分配對法，看看你和誰會是天賜良緣吧！"></TipsAlert>
            <b-row class="my-2">
                <b-col cols="12" lg="6" class="mb-3">
                    <label>姓氏</label>
                    <b-form-input v-model="firstname" placeholder="" class="border-0 " readonly></b-form-input>
                </b-col>
                <b-col cols="12" lg="6" class="mb-3">
                    <label>姓名</label>
                    <b-form-input v-model="lastname" class="border-0 " readonly></b-form-input>
                </b-col>
            </b-row>
            <hr>
            <b-row class="mt-2">
                <b-col cols="12" lg="6" class="mb-3">
                    <label>性別</label>
                    <b-form-input v-model="male" placeholder="" class="border-0 " readonly></b-form-input>
                </b-col>
                <b-col cols="12" lg="6" class="mb-3">
                    <label>email</label>
                    <b-input-group>
                        <b-form-input v-if="mailStatus" type="email" v-model="Mail" readonly></b-form-input>
                        <b-form-input v-else type="email" v-model="formData.email" placeholder="輸入信箱取得最新姓名DNA消息"
                                      @change="checkvalue('email')"></b-form-input>
                        <b-input-group-append>
                            <b-button v-if="mailStatus" variant="primary" @click="editMail">編輯</b-button>
                            <b-button v-else variant="primary" @click="saveMail">
                                <b-spinner small v-if="mailEditLoading"></b-spinner>
                                儲存
                            </b-button>
                            <b-button v-if="!mailStatus" variant="outline-secondary" @click="cencelMail">取消</b-button>
                        </b-input-group-append>
                        <b-form-invalid-feedback :state="formData.emailcheck">
                            {{ formData.emailmsg }}
                        </b-form-invalid-feedback>
                    </b-input-group>

                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col cols="12" lg="6" class="mb-3">
                    <label>電話</label>


                    <!--<b-form-input   placeholder="" class="border-0 " readonly></b-form-input>-->
                    <b-input-group v-if="false">
                        <b-form-input v-if="phoneStatus" type="text" v-model="Phone" readonly></b-form-input>
                        <b-form-input v-else type="text" v-model="formData.phone"
                                      @change="checkvalue('phone')"></b-form-input>

                        <b-input-group-append>
                            <b-button v-if="phoneStatus" variant="primary" @click="editPhone">編輯</b-button>

                            <b-button v-else variant="primary" @click="savePhone">
                                <b-spinner small v-if="phoneEditLoading"></b-spinner>
                                儲存
                            </b-button>
                            <b-button v-if="!phoneStatus" variant="outline-secondary" @click="cencelPhone">取消</b-button>
                        </b-input-group-append>
                        <b-form-invalid-feedback :state="formData.phonecheck">
                            {{ formData.phonemsg }}
                        </b-form-invalid-feedback>
                    </b-input-group>
                    <b-form-input v-if="false" type="text" v-model="Phone" readonly></b-form-input>
                    <b-form-input v-if="username !== ''" type="text" v-model="username" readonly></b-form-input>

                </b-col>
                <b-col cols="12" lg="6" class="">

                    <b-form-group
                            class="mb-0"
                            label="點數"
                            description=""
                    >
                        <b-input-group>
                            <b-form-input type="text" v-model="points" readonly></b-form-input>
                            <b-input-group-append>
                                <b-button variant="primary" to="/Payment">購買</b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>

                </b-col>
            </b-row>
            <hr>


            <ProfileMemberCard :Profile="profiledata"></ProfileMemberCard>

            <h5 class="mb-3">購買資訊</h5>
            <b-row class="my-2">
                <b-col cols="12" lg="6" class="mb-3">
                    <b-form-group
                            class="mb-0"
                            label="訂單紀錄"

                    >
                        <b-button pill variant="outline-primary" to="/PaymentLog">查詢</b-button>
                    </b-form-group>
                </b-col>
                <b-col cols="12" lg="6" class="mb-3">
                    <b-form-group
                            class="mb-0"
                            label="點數消費紀錄"

                    >
                        <b-button pill variant="outline-primary" to="/UsementLog">查詢</b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <hr>
            <h5 class="mb-3">帳戶資訊</h5>


            <b-form-group v-if="!pwdStatus" class="mb-0" label="密碼修改">
                <b-button  pill variant="outline-primary" to="/ChangePW" :disabled="pwdStatus">更改密碼</b-button>

            </b-form-group>


            <BindAccount v-else :Username="username"></BindAccount>


        </b-container>


    </div>


</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import PageHeader from '@/components/PageHeader.vue'
import {getStore} from '@/config/mUtils'

import TipsAlert from '@/components/TipsAlert.vue'
import BindAccount from '@/components/BindAccount.vue'
import ProfileMemberCard from '@/components/ProfileMemberCard.vue'

import { alertModel } from '@/service/commuse'

import { mapState } from 'vuex'

export default {
  name: 'Profile',
  components: {Nav, PageHeader, TipsAlert, BindAccount, ProfileMemberCard},
  data () {
    return {
      productName: '基本資料',
      mailStatus: false,
      phoneStatus: false,
      Mail: '',
      Phone: '',
      formData: {
        phone: '',
        phonecheck: null,
        phonemsg: '',
        email: '',
        emailcheck: null,
        emailmsg: '',
      },
      phoneEditLoading: false,
      mailEditLoading: false,
      NormalMemberData: {},
      SalesMemberData: {},
      MemberPackage: [],
      UserPlan: {}
    }
  },
  mounted () {
    // this.GetMemberDetail();

  },
  computed: {
    ...mapState(['profiledata']),
    pwdStatus: function () {return this.profiledata !== null ? (this.profiledata.pwdStatus == 0 ? true : false) : false},
    username: function () {return this.profiledata !== null ? this.profiledata.username : ''},
    firstname: function () {return this.profiledata !== null ? this.profiledata.first_name : ''},
    lastname: function () {return this.profiledata !== null ? this.profiledata.last_name : ''},
    male: function () {return this.profiledata !== null ? (this.profiledata.male == 1 ? '男' : '女') : ''},
    points: function () {return this.profiledata !== null ? this.profiledata.point : '0'},
    logintype: function () {return this.profiledata !== null ? (this.profiledata.login_type == 0 ? false : true) : '0'},
  },
  created () {
    if (this.profiledata !== null) {
      this.Mail = this.profiledata.mail
      this.Phone = this.profiledata.phone
      this.formData.email = this.profiledata.mail
      this.formData.phone = this.profiledata.phone
      this.profiledata.mail || '' ? this.mailStatus = true : ''
      this.profiledata.phone || '' ? this.phoneStatus = true : ''
    }
  },

  methods: {
    editMail () {
      this.mailStatus = false
    },
    saveMail () {

      if (!this.formData.emailcheck) {
        alertModel(this, '系統訊息', '請填醒正確的信箱')
      } else {
        this.mailEditLoading = true
        this.updataApi({mail: this.formData.email})
      }
    },
    cencelMail () {
      this.mailStatus = true
      this.formData.email = this.profiledata.mail
      this.formData.emailmsg = ''
      this.formData.emailcheck = true

    },
    editPhone () {
      this.phoneStatus = false
    },
    savePhone () {

      this.checkvalue('phone')

      if (!this.formData.phonecheck) {
        alertModel(this, '系統訊息', '請填醒正確的電話號碼')
      } else {
        this.phoneEditLoading = true
        this.updataApi({phone: this.formData.phone})

      }
    },
    cencelPhone () {
      this.phoneStatus = true
      this.formData.phone = this.profiledata.phone
      this.formData.phonemsg = ''
      this.formData.phonecheck = true
    },
    checkvalue (way) {
      switch (way) {

        case 'phone':
          let isPhone = /^09\d{8}$/
          if (this.formData.phone.length == 0) {
            this.formData.phonemsg = '請填寫行動電話號碼'
            this.formData.phonecheck = false
          }
          if (this.formData.phone.length < 10 || (!isPhone.test(this.formData.phone))) {
            this.formData.phonemsg = '請填寫行動電話號碼'
            this.formData.phonecheck = false
          }
          else {
            this.formData.phonemsg = ''
            this.formData.phonecheck = true
          }
          break

        case 'email':
          let emailRule = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/
          if (!emailRule.test(this.formData.email)) {
            this.formData.emailmsg = '請輸入您的信箱'
            this.formData.emailcheck = false
          } else {
            this.formData.emailcheck = true
          }
          break

      }

    },
    updataApi (data) {

      this.$store.dispatch('actionEditMemberInfo', data)
        .then((res) => {
          if (data.hasOwnProperty('mail')) {
            this.Mail = data.mail
            this.mailEditLoading = false
            this.mailStatus = true
          }
          if (data.hasOwnProperty('phone')) {
            this.Phone = data.phone
            this.phoneEditLoading = false
            this.phoneStatus = true
          }

        })
        .catch((res) => {
          alertModel(this, '系統訊息', res.message)
          this.mailEditLoading = false
          this.phoneEditLoading = false
        })

    },
    GetMemberDetail () {
      this.$store.dispatch('actionGetMemberDetail', {})
        .then((res) => {

          this.NormalMemberData = res.data.NormalMemberData
          this.SalesMemberData = res.data.SalesMemberData
          this.MemberPackage = res.data.MemberPackage

        })
        .catch((res) => {

        })
    },
    bindLine(){

      let Token = getStore('NameAppUserToken')
      this.$store.dispatch('actionLineAuth', {
        SalesInviteCode:'BINDLINE',
        token:Token
      }).then((res) => {

        window.location.href = res.data;
      })
    }

  }
}
</script>
